export default __webpack_public_path__ + "static/6-19ad4bf7845d4b590c1da9113bd1b2f3.svg";